export const CONVERSATION_ACTIVE_CONVERSATION = 'CONVERSATION_ACTIVE_CONVERSATION';
export const CONVERSATION_ACTIVE_CLEAR_CONVERSATION = 'CONVERSATION_ACTIVE_CLEAR_CONVERSATION';
